import React from 'react';

// A trend shape next to a headline number, not a chart: no axes, no grid, no
// tooltip. It answers "which way is this going", and the tile's own figure and
// delta carry the precision. Flat data draws a flat line rather than a fake peak.
export default function Sparkline({ values = [], color, width = 120, height = 28, label }) {
  const points = values.filter((v) => Number.isFinite(v));
  if (points.length < 2) return null;

  const max = Math.max(...points);
  const min = Math.min(...points);
  const span = max - min || 1;
  const stepX = width / (points.length - 1);
  // 1px inset top and bottom so a 2px stroke is never clipped by the viewBox.
  const y = (v) => height - 1 - ((v - min) / span) * (height - 2);
  const line = points.map((v, i) => `${i === 0 ? 'M' : 'L'}${(i * stepX).toFixed(1)},${y(v).toFixed(1)}`).join(' ');
  const area = `${line} L${width},${height} L0,${height} Z`;

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} role="img"
         aria-label={label || 'Trend'} className="overflow-visible">
      <path d={area} fill={color} fillOpacity="0.12" />
      <path d={line} fill="none" stroke={color} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
